import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Ban, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const opts = { withCredentials: true };

export const AvailabilityPanel = () => {
  const [days, setDays] = useState([]);
  const load = () => axios.get(`${API}/slots/admin`, opts).then(({ data }) => setDays(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (date, time, blocked) => {
    if (blocked) await axios.delete(`${API}/slot-blocks`, { ...opts, params: time ? { date, time } : { date } });
    else await axios.post(`${API}/slot-blocks`, { date, time: time || null }, opts);
    load();
  };

  return (
    <div data-testid="availability-panel" className="bg-white rounded-2xl border border-teal-50 overflow-hidden">
      <div className="p-5 border-b border-teal-50">
        <h2 className="font-semibold text-teal-900">Video consultation availability</h2>
        <p className="text-xs text-slate-500">Mon, Tue, Thu, Fri · 10:30–11:30 IST · 15-minute slots · next 2 weeks. Block a whole day or single slots for holidays or travel.</p>
      </div>
      {days.map((d) => (
        <div key={d.date} data-testid={`avail-day-${d.date}`} className="flex flex-wrap items-center gap-3 p-4 border-b border-teal-50 last:border-0">
          <div className="w-40 shrink-0">
            <div className="font-semibold text-teal-900 text-sm">{d.weekday}</div>
            <div className="text-xs text-slate-500">{new Date(`${d.date}T00:00:00`).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}</div>
          </div>
          <div className="flex flex-wrap gap-2 flex-1">
            {d.slots.map((s) => (
              <button key={s.time} data-testid={`avail-slot-${d.date}-${s.time.replace(':', '')}`} disabled={!!s.booked_by || d.day_blocked || s.past}
                onClick={() => toggle(d.date, s.time, s.blocked)} title={s.booked_by ? `Booked: ${s.booked_by}` : ''}
                className={`px-3 py-1.5 rounded-lg text-xs font-semibold border transition-colors ${s.booked_by ? 'bg-teal-700 text-white border-teal-700' : s.blocked ? 'bg-red-50 text-red-600 border-red-200 line-through' : s.past ? 'text-slate-300 border-slate-100' : 'text-teal-800 border-teal-100 hover:border-red-300'}`}>
                {s.time}{s.booked_by && ` · ${s.booked_by}`}
              </button>
            ))}
          </div>
          <button data-testid={`avail-day-toggle-${d.date}`} onClick={() => toggle(d.date, null, d.day_blocked)}
            className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-xs font-semibold transition-colors ${d.day_blocked ? 'bg-teal-50 text-teal-700 hover:bg-teal-100' : 'bg-red-50 text-red-600 hover:bg-red-100'}`}>
            {d.day_blocked ? <><CheckCircle2 size={14} /> Open day</> : <><Ban size={14} /> Block day</>}
          </button>
        </div>
      ))}
    </div>
  );
};
